/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable camelcase */
import { nanoid } from 'nanoid'
import { cloneDeep } from 'lodash'
import store from '../../store'

import {
  BIKE_FACILITY_TYPE,
  BIKE_FACILITY_TYPE_VALUES,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES,
  STREET_BUFFER_WIDTH,
  STREET_BUFFER_WIDTH_VALUES,
  USABLE_BIKEWAY_WIDTH,
  USABLE_BIKEWAY_WIDTH_VALUES
} from '../constants/bike'
import {
  addMultipleSegments,
  addSegment,
  addSharedLaneSegment,
  updateFinalStreet
} from './multimodal.utils'
import { setBicycleInputs } from '../slices/criteriaSelection/bicycle'

export function setbikeStreetmixInput(field) {
  const { bicycle, street } = store.getState()
  const {
    bike_facility_type,
    usable_bikeway_width,
    shared_lane_pavement_markings_present,
    street_buffer_width
  } = bicycle
  const { segments } = street

  switch (field) {
    case BIKE_FACILITY_TYPE:
    case USABLE_BIKEWAY_WIDTH:
      // Check if input is NO Bike Lane
      if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[0]) {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllBikeBuffers(segmentCopy)
        segmentCopy = removeAllBikeLanes(segmentCopy)

        updateFinalStreet(segmentCopy)
      } else {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllBikeBuffers(segmentCopy)
        segmentCopy = removeAllBikeLanes(segmentCopy)
        segmentCopy = removeAllSharedPavementLanes(segmentCopy)

        const bikeLaneOutbound = {
          type: 'bike-lane',
          variantString: 'outbound|regular|road',
          width: 6,
          variant: {
            'bike-direction': 'outbound',
            'bike-asphalt': 'regular',
            elevation: 'road'
          }
        }
        const bikeLaneInbound = {
          type: 'bike-lane',
          variantString: 'inbound|regular|road',
          variant: {
            'bike-direction': 'inbound',
            'bike-asphalt': 'regular',
            elevation: 'road'
          },
          width: 6
        }
        const buffer = {
          type: 'divider',
          variantString: 'striped-buffer',
          width: 6
        }

        // Determine width of bikelane based on usable bikeway width
        if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[0]) {
          bikeLaneOutbound.width = 14
          bikeLaneInbound.width = 14
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[1]) {
          bikeLaneOutbound.width = 11
          bikeLaneInbound.width = 11
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[2]) {
          bikeLaneOutbound.width = 10
          bikeLaneInbound.width = 10
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[3]) {
          bikeLaneOutbound.width = 8
          bikeLaneInbound.width = 8
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[4]) {
          bikeLaneOutbound.width = 6.5
          bikeLaneInbound.width = 6.5
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[5]) {
          bikeLaneOutbound.width = 5
          bikeLaneInbound.width = 5
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[6]) {
          bikeLaneOutbound.width = 4
          bikeLaneInbound.width = 4
        } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[7]) {
          bikeLaneOutbound.width = 3.5
          bikeLaneInbound.width = 3.5
        }

        // in case of two way, the usable width must be split between 2 lanes
        if (
          bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4] ||
          bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]
        ) {
          if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[0]) {
            bikeLaneOutbound.width = 7
            bikeLaneInbound.width = 7
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[1]) {
            bikeLaneOutbound.width = 5.5
            bikeLaneInbound.width = 5.5
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[2]) {
            bikeLaneOutbound.width = 5
            bikeLaneInbound.width = 5
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[3]) {
            bikeLaneOutbound.width = 4
            bikeLaneInbound.width = 4
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[4]) {
            bikeLaneOutbound.width = 3.25
            bikeLaneInbound.width = 3.25
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[5]) {
            bikeLaneOutbound.width = 2.5
            bikeLaneInbound.width = 2.5
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[6]) {
            bikeLaneOutbound.width = 2
            bikeLaneInbound.width = 2
          } else if (usable_bikeway_width === USABLE_BIKEWAY_WIDTH_VALUES[7]) {
            bikeLaneOutbound.width = 1.75
            bikeLaneInbound.width = 1.75
          }
        }

        let firstLaneIndex = segmentCopy.findIndex((segment) =>
          ['drive-lane', 'bus-lane', 'brt-lane'].includes(segment?.type)
        )
        // Check if road is one way or two way
        const segmentDirection = segmentCopy.map((segment) =>
          segment.type === 'drive-lane' && segment?.variant?.direction
            ? segment?.variant?.direction
            : null
        )

        const isRoadTwoWay =
          segmentDirection?.includes('inbound') &&
          segmentDirection?.includes('outbound')
        // if no drive lanes, add drive lanes
        if (firstLaneIndex === -1) {
          // if lanes do not exsist add the lanes
          const driveLane = {
            type: 'drive-lane',
            width: 10,
            variantString: 'inbound|car',
            variant: {
              direction: 'inbound',
              'car-type': 'car'
            },
            elevation: 0
          }
          const toBeAddedSegments = [
            { ...driveLane, id: nanoid() },
            {
              ...driveLane,
              variantString: 'outbound|car',
              variant: { ...driveLane.variant, direction: 'outbound' },
              id: nanoid()
            }
          ]
          segmentCopy = addMultipleSegments(
            toBeAddedSegments,
            Math.floor(segmentCopy.length / 2),
            segmentCopy
          )

          // since new lanes are added, update first lane index
          firstLaneIndex = segmentCopy.findIndex(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )
        }

        // Get drive Lanes elevation
        const driveLaneElevation = segmentCopy.find(
          (segment) => segment?.type === 'drive-lane'
        )?.elevation

        if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[1]) {
          segmentCopy = addSegment(
            firstLaneIndex,
            { ...bikeLaneInbound, id: nanoid() },
            segmentCopy
          )
        } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2]) {
          // If Bike facitlity is one way in-roadway, then add buffer width
          // if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[0]) {
          //   buffer.width = 6.5
          // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[1]) {
          //   buffer.width = 6
          // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[2]) {
          //   buffer.width = 2.5
          // }
          const toBeAddedSegments = [
            { ...bikeLaneInbound, id: nanoid() },
            { ...buffer, id: nanoid() }
          ]

          //  const insertIndex = firstLaneIndex - 1 === -1 ? 0 : firstLaneIndex - 1

          segmentCopy = addMultipleSegments(
            toBeAddedSegments,
            firstLaneIndex,
            segmentCopy
          )
        } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[3]) {
          // if the option clicked is buffer width
          if (field === STREET_BUFFER_WIDTH) {
            // if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[0]) {
            //   buffer.width = 6.5
            // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[1]) {
            //   buffer.width = 6
            // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[2]) {
            //   buffer.width = 2.5
            // }
            const toBeAddedSegments = [
              {
                ...bikeLaneInbound,
                elevation: driveLaneElevation + 1,
                id: nanoid()
              },
              { ...buffer, id: nanoid() }
            ]

            //  const insertIndex = firstLaneIndex - 1 === -1 ? 0 : firstLaneIndex - 1

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              firstLaneIndex,
              segmentCopy
            )
          } else {
            segmentCopy = addSegment(
              firstLaneIndex,
              {
                ...bikeLaneInbound,
                elevation: driveLaneElevation + 1,
                id: nanoid()
              },
              segmentCopy
            )
          }
        } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4]) {
          // If Bike facitlity is two way in-roadway, then add buffer width
          // if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[0]) {
          //   buffer.width = 6.5
          // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[1]) {
          //   buffer.width = 6
          // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[2]) {
          //   buffer.width = 2.5
          // }
          const toBeAddedSegments = [
            { ...bikeLaneInbound, id: nanoid() },
            { ...bikeLaneOutbound, id: nanoid() },
            { ...buffer, id: nanoid() }
          ]

          //  const insertIndex = firstLaneIndex - 1 === -1 ? 0 : firstLaneIndex - 1

          segmentCopy = addMultipleSegments(
            toBeAddedSegments,
            firstLaneIndex,
            segmentCopy
          )
        } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]) {
          if (field === STREET_BUFFER_WIDTH) {
            // if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[0]) {
            //   buffer.width = 6.5
            // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[1]) {
            //   buffer.width = 6
            // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[2]) {
            //   buffer.width = 2.5
            // }
            const toBeAddedSegments = [
              {
                ...bikeLaneInbound,
                elevation: driveLaneElevation + 1,
                id: nanoid()
              },
              {
                ...bikeLaneOutbound,
                elevation: driveLaneElevation + 1,
                id: nanoid()
              },
              { ...buffer, id: nanoid() }
            ]

            //  const insertIndex = firstLaneIndex - 1 === -1 ? 0 : firstLaneIndex - 1

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              firstLaneIndex,
              segmentCopy
            )
          } else {
            const toBeAddedSegments = [
              {
                ...bikeLaneInbound,
                elevation: driveLaneElevation + 1,
                id: nanoid()
              },
              {
                ...bikeLaneOutbound,
                elevation: driveLaneElevation + 1,
                id: nanoid()
              }
            ]

            //  const insertIndex = firstLaneIndex - 1 === -1 ? 0 : firstLaneIndex - 1

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              firstLaneIndex,
              segmentCopy
            )
          }
        }

        // if Roadway is two way, then add remaining segments
        if (isRoadTwoWay) {
          // Reverse segments to find last lane id
          const copyOfSegmentsToReverse = [...segmentCopy]

          const lastLaneId = copyOfSegmentsToReverse
            .reverse()
            .find((segment) =>
              ['drive-lane', 'bus-lane', 'brt-lane'].includes(segment?.type)
            ).id

          const lastLandeIndex = segmentCopy.findIndex(
            (segment) => segment?.id === lastLaneId
          )
          // Bike lane no buffer
          if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[1]) {
            segmentCopy = addSegment(
              lastLandeIndex + 1,
              { ...bikeLaneOutbound, id: nanoid() },
              segmentCopy
            )
          } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2]) {
            // If Bike facitlity is one way in-roadway, then add buffer width
            // if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[0]) {
            //   buffer.width = 6.5
            // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[1]) {
            //   buffer.width = 6
            // } else if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[2]) {
            //   buffer.width = 2.5
            // }
            const toBeAddedSegments = [
              { ...buffer, id: nanoid() },
              { ...bikeLaneOutbound, id: nanoid() }
            ]

            //  const insertIndex = firstLaneIndex - 1 === -1 ? 0 : firstLaneIndex - 1

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              lastLandeIndex + 1,
              segmentCopy
            )
          } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[3]) {
            if (field === STREET_BUFFER_WIDTH) {
              // if (street_buffer_width === STREET_BUFFER_WIDTH_VALUES[0]) {
              //   buffer.width = 6.5
              // } else if (
              //   street_buffer_width === STREET_BUFFER_WIDTH_VALUES[1]
              // ) {
              //   buffer.width = 6
              // } else if (
              //   street_buffer_width === STREET_BUFFER_WIDTH_VALUES[2]
              // ) {
              //   buffer.width = 2.5
              // }
              const toBeAddedSegments = [
                { ...buffer, id: nanoid() },
                {
                  ...bikeLaneOutbound,
                  elevation: driveLaneElevation + 1,
                  id: nanoid()
                }
              ]

              segmentCopy = addMultipleSegments(
                toBeAddedSegments,
                lastLandeIndex + 1,
                segmentCopy
              )
            } else {
              segmentCopy = addSegment(
                lastLandeIndex + 1,
                {
                  ...bikeLaneOutbound,
                  elevation: driveLaneElevation + 1,
                  id: nanoid()
                },
                segmentCopy
              )
            }
          }
        }

        updateFinalStreet(segmentCopy)
      }
      break
    case SHARED_LANE_PAVEMENT_MARKINGS_PRESENT:
      // Check if input is NO Shared Lane Pavement Markings
      if (
        shared_lane_pavement_markings_present ===
        SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[2]
      ) {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllSharedPavementLanes(segmentCopy)

        updateFinalStreet(segmentCopy)
      } else {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllSharedPavementLanes(segmentCopy)

        let firstDriveLaneIndex = segmentCopy.findIndex(
          (segment) =>
            segment?.type === 'drive-lane' ||
            segment?.type === 'bus-lane' ||
            segment?.type === 'brt-lane'
        )
        // find first segment type
        const firstSegementType = segmentCopy.find(
          (lane, index) => index === firstDriveLaneIndex
        ).type

        const sharedDriveLane = {
          type: 'drive-lane',
          variantString: 'inbound|sharrow',
          width: 12,
          elevation: 0,
          variant: {
            direction: 'inbound',
            'car-type': 'sharrow'
          }
        }

        const sharedDriveLaneLessThan250 = {
          type: 'drive-lane',
          variantString: 'inbound|sharrow|copy',
          width: 12,
          elevation: 0,
          variant: {
            direction: 'inbound',
            'car-type': 'sharrow'
          }
        }

        const sharedBusLane = {
          type: 'bus-lane',
          variantString: 'inbound|shared|typical',
          variant: {
            direction: 'inbound',
            'bus-type': 'typical'
          },
          width: 12,
          elevation: 0
        }

        const sharedBusLaneLessThan250 = {
          type: 'bus-lane',
          variantString: 'inbound|shared|typical|copy',
          width: 12,
          elevation: 0,
          variant: {
            direction: 'inbound',
            'bus-type': 'typical'
          }
        }

        if (
          shared_lane_pavement_markings_present ===
          SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[1]
        ) {
          // If there are no drive lanes, add shared lane to the beginning
          if (firstDriveLaneIndex === -1) {
            // if lanes do not exsist add the lanes
            const driveLane = {
              type: 'drive-lane',
              width: 10,
              variantString: 'inbound|car',
              variant: {
                direction: 'inbound',
                'car-type': 'car'
              },
              elevation: 0
            }
            const toBeAddedSegments = [
              { ...driveLane, id: nanoid() },
              {
                ...driveLane,
                variantString: 'outbound|car',
                variant: { ...driveLane.variant, direction: 'outbound' },
                id: nanoid()
              }
            ]
            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              Math.floor(segmentCopy.length / 2),
              segmentCopy
            )

            // since new lanes are added, update first lane index
            firstDriveLaneIndex = segmentCopy.findIndex(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )
          }
          segmentCopy = addSharedLaneSegment(
            firstDriveLaneIndex - 1 === -1 ? 0 : firstDriveLaneIndex,
            firstSegementType === 'drive-lane'
              ? { ...sharedDriveLane, id: nanoid() }
              : { ...sharedBusLane, id: nanoid() },
            segmentCopy
          )
        } else if (
          shared_lane_pavement_markings_present ===
          SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[0]
        ) {
          // If there are no drive lanes, add shared lane to the beginning
          if (firstDriveLaneIndex === -1) {
            // if lanes do not exsist add the lanes
            const driveLane = {
              type: 'drive-lane',
              width: 10,
              variantString: 'inbound|car',
              variant: {
                direction: 'inbound',
                'car-type': 'car'
              },
              elevation: 0
            }
            const toBeAddedSegments = [
              { ...driveLane, id: nanoid() },
              {
                ...driveLane,
                variantString: 'outbound|car',
                variant: { ...driveLane.variant, direction: 'outbound' },
                id: nanoid()
              }
            ]
            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              Math.floor(segmentCopy.length / 2),
              segmentCopy
            )

            // since new lanes are added, update first lane index
            firstDriveLaneIndex = segmentCopy.findIndex(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )
          }
          segmentCopy = addSharedLaneSegment(
            firstDriveLaneIndex - 1 === -1 ? 0 : firstDriveLaneIndex,
            firstSegementType === 'drive-lane'
              ? { ...sharedDriveLaneLessThan250, id: nanoid() }
              : { ...sharedBusLaneLessThan250, id: nanoid() },
            segmentCopy
          )
        }
        // Check if road is one way or two way
        const segmentDirection = segmentCopy.map((segment) =>
          segment?.type === 'drive-lane' ||
          segment?.type === 'bus-lane' ||
          (segment?.type === 'brt-lane' && segment?.variant?.direction)
            ? segment?.variant?.direction
            : null
        )

        const isRoadTwoWay =
          segmentDirection?.includes('inbound') &&
          segmentDirection?.includes('outbound')

        // if Roadway is two way, then add remaining segments
        if (isRoadTwoWay) {
          // Reverse segments to find last lane id
          const copyOfSegmentsToReverse = [...segmentCopy]

          const lastLaneId = copyOfSegmentsToReverse
            .reverse()
            .find((segment) =>
              ['drive-lane', 'bus-lane', 'brt-lane'].includes(segment?.type)
            ).id

          const lastLandeIndex = segmentCopy.findIndex(
            (segment) => segment?.id === lastLaneId
          )
          const lastLaneType = segmentCopy.find(
            (segment) => segment?.id === lastLaneId
          ).type
          if (
            shared_lane_pavement_markings_present ===
            SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[1]
          ) {
            segmentCopy = addSharedLaneSegment(
              lastLandeIndex,
              lastLaneType === 'drive-lane'
                ? {
                    ...sharedDriveLane,
                    variantString: 'outbound|sharrow',
                    variant: {
                      direction: 'outbound',
                      'car-type': 'sharrow'
                    },
                    id: nanoid()
                  }
                : {
                    ...sharedBusLane,
                    variantString: 'outbound|shared|typical',
                    variant: {
                      direction: 'outbound',
                      'bus-type': 'typical'
                    },
                    id: nanoid()
                  },
              segmentCopy
            )
          } else if (
            shared_lane_pavement_markings_present ===
            SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[0]
          ) {
            segmentCopy = addSharedLaneSegment(
              lastLandeIndex,
              lastLaneType === 'drive-lane'
                ? {
                    ...sharedDriveLaneLessThan250,
                    variantString: 'outbound|sharrow|copy',
                    variant: {
                      direction: 'outbound',
                      'car-type': 'sharrow'
                    },
                    id: nanoid()
                  }
                : {
                    ...sharedBusLaneLessThan250,
                    variantString: 'outbound|shared|typical|copy',
                    variant: {
                      direction: 'outbound',
                      'bus-type': 'typical'
                    },
                    id: nanoid()
                  },
              segmentCopy
            )
          }
        }

        updateFinalStreet(segmentCopy)
      }
      break

    default:
      break
  }
}

function removeAllBikeLanes(segmentCopy) {
  // get all bieklane indexes
  const bikeLaneIndexArr = segmentCopy
    .map((segment, index) => {
      if (segment?.type === 'bike-lane') {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !bikeLaneIndexArr.includes(index)
  )
}

function removeAllSharedPavementLanes(segmentCopy) {
  // identify if shared lanes are bus or car lanes
  const segmentType = segmentCopy
    .map((segment, index) => {
      if (
        (segment?.type === 'drive-lane' ||
          segment?.type === 'bus-lane' ||
          segment?.type === 'brt-lane') &&
        (segment?.variantString?.includes('sharrow') ||
          segment?.variantString?.includes('shared'))
      ) {
        return segment?.type
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  // get all sahred bieklane indexes
  const sharedLanesIndexes = segmentCopy
    .map((segment, index) => {
      if (
        (segment?.type === 'drive-lane' ||
          segment?.type === 'bus-lane' ||
          segment?.type === 'brt-lane') &&
        (segment?.variantString?.includes('sharrow') ||
          segment?.variantString?.includes('shared'))
      ) {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)

  const driveLane = {
    type: 'drive-lane',
    width: 12,
    variantString: 'inbound|car',
    variant: {
      direction: 'inbound',
      'car-type': 'car'
    },
    elevation: 0
  }

  const busLane = {
    type: 'bus-lane',
    width: 12,
    variantString: 'inbound|regular|typical',
    variant: {
      direction: 'inbound',
      'bus-type': 'typical'
    }
  }
  segmentCopy = segmentCopy.filter(
    (segment, index) => !sharedLanesIndexes.includes(index)
  )

  // check if two way
  if (sharedLanesIndexes.length === 2) {
    segmentCopy = addSegment(
      sharedLanesIndexes[0],
      segmentType[0] === 'drive-lane'
        ? {
            ...driveLane,

            id: nanoid()
          }
        : {
            ...busLane,

            id: nanoid()
          },
      segmentCopy
    )
    segmentCopy = addSegment(
      sharedLanesIndexes[1],
      segmentType[1] === 'drive-lane'
        ? {
            ...driveLane,
            variantString: 'outbound|car',
            variant: {
              direction: 'outbound',
              'car-type': 'car'
            },
            id: nanoid()
          }
        : {
            ...busLane,
            variantString: 'outbound|regular|typical',
            variant: {
              direction: 'outbound',
              'bus-type': 'typical'
            },
            id: nanoid()
          },
      segmentCopy
    )
  } else {
    for (let i = 0; i < sharedLanesIndexes.length; i++) {
      segmentCopy = addSegment(
        sharedLanesIndexes[i],
        {
          ...driveLane,

          id: nanoid()
        },
        segmentCopy
      )
    }
  }

  return segmentCopy
}
function removeAllBikeBuffers(segmentCopy) {
  // get all bieklane indexes
  let firstDriveLaneIndex = segmentCopy.findIndex(
    (segment) =>
      segment?.type === 'drive-lane' ||
      segment?.type === 'bus-lane' ||
      segment?.type === 'brt-lane'
  )
  // Reverse segments to find last lane id
  const copyOfSegmentsToReverse = [...segmentCopy]

  const lastLaneId = copyOfSegmentsToReverse
    .reverse()
    .find(
      (segment) =>
        segment?.type === 'drive-lane' ||
        segment?.type === 'bus-lane' ||
        segment?.type === 'brt-lane'
    )?.id

  const lastDriveLandeIndex = segmentCopy.findIndex(
    (segment) => segment?.id === lastLaneId
  )
  const sharedLanes = segmentCopy
    .map((segment, index) => {
      if (
        segment?.type === 'divider' &&
        segment?.variantString === 'striped-buffer' &&
        segmentCopy[index - 1]?.type === 'bike-lane' &&
        (segmentCopy[index + 1]?.type === 'drive-lane' ||
          segmentCopy[index + 1]?.type === 'bus-lane' ||
          segmentCopy[index + 1]?.type === 'brt-lane') &&
        index + 1 === firstDriveLaneIndex
      ) {
        return index
      } else if (
        segment?.type === 'divider' &&
        segment?.variantString === 'striped-buffer' &&
        segmentCopy[index + 1].type === 'bike-lane' &&
        (segmentCopy[index - 1]?.type === 'drive-lane' ||
          segmentCopy[index - 1]?.type === 'bus-lane' ||
          segmentCopy[index - 1]?.type === 'brt-lane') &&
        index - 1 === lastDriveLandeIndex
      ) {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter((segment, index) => !sharedLanes.includes(index))
}
